export default __webpack_public_path__ + "static/media/active-left.1a3edde6.svg";